var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"box-centered"},[_c('div',{staticClass:"wc-row"},[_c('div',{staticClass:"wc-col"},[_c('cp-motor-vehicle-change-container',{attrs:{"policy-id":_vm.policyId}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }